import { render, staticRenderFns } from "./grade-schedule.vue?vue&type=template&id=388bd350&scoped=true"
import script from "./grade-schedule.vue?vue&type=script&lang=js"
export * from "./grade-schedule.vue?vue&type=script&lang=js"
import style0 from "./grade-schedule.vue?vue&type=style&index=0&id=388bd350&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388bd350",
  null
  
)

export default component.exports